import { render } from "./Marke.vue?vue&type=template&id=cf95135e&scoped=true"
import script from "./Marke.vue?vue&type=script&lang=js"
export * from "./Marke.vue?vue&type=script&lang=js"

import "./Marke.vue?vue&type=style&index=0&id=cf95135e&scoped=true&lang=scss"

import exportComponent from "/var/jenkins_home/workspace/tl-demo-web_v2.0.9.4/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cf95135e"]])

export default __exports__